import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { theme } from '../theme/theme'
import { BodyXl } from '../components/styles/Typography'
import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { useTranslation } from 'react-i18next'
import { LoginErrorCode } from '@estercare/ester-shared'
import { SSO_LOGIN_FAILED } from '../utils/loginErrors'

const ERROR_TRANSLATION_KEYS: Record<string, string> = {
  [LoginErrorCode.SSO_ORG_NOT_CONFIGURED]: 'common.errors.ssoOrgNotConfigured',
  [LoginErrorCode.USE_SSO_LOGIN]: 'common.errors.ssoUseSsoLogin',
  [LoginErrorCode.USE_PASSWORD_LOGIN]: 'common.errors.ssoUsePasswordLogin',
  [LoginErrorCode.SSO_ACCOUNT_CONFLICT]: 'common.errors.ssoAccountConflict',
  [SSO_LOGIN_FAILED]: 'common.errors.ssoLoginFailed',
}

export const ErrorPage = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const { logout } = useAuth0()
  const errorMessage = location.state?.errorMessage || 'An error occurred'
  const translationKey = ERROR_TRANSLATION_KEYS[errorMessage]

  useEffect(() => {
    if (errorMessage.includes('Missing Refresh Token')) {
      logout({
        openUrl() {
          navigate('/login')
        },
      })
    }
  }, [errorMessage, logout, navigate])

  if (errorMessage.includes('Missing Refresh Token')) {
    return null
  }

  return (
    <ErrorWrapper>
      <BodyXl>{translationKey ? t(translationKey) : errorMessage}</BodyXl>
    </ErrorWrapper>
  )
}

const ErrorWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.color.plum};
`
